import axios from "src/lib/axios";

export const findAllOrderDraft = ({
  keyword = null,
  page = null,
  page_size = null,
  order_case = "desc",
}) => {
  return axios.get(`/order-draft/find-all`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      order_case: order_case,
    },
  });
};

export const findOneOrderDraft = (id) => {
  return axios.get(`/order-draft/order-draft-detail/${id}`);
};

export const createOrderDraft = (info) => {
  return axios.post(`/order-draft/create-order-draft`, info, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

export const updateOrderDraft = (info) =>
  axios.patch(`/order-draft/update-order-draft`, info);
